var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoInfomaticaActivo200X70(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 63,
    viewBox: "0 0 180 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2119_40747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.27035 34.5352H2.7002V52.7658H7.27035V34.5352Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8688 44.804L14.0013 34.5352H10.5137V52.7658H15.0838V42.7653L23.8968 52.7658H27.439V34.5352H22.8688V44.804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3784 52.7658H34.9486V46.3297H42.8449V42.3888H34.9486V38.5301H44.0867V34.5352H30.3784V52.7658Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7198 34.1592C50.1762 34.1592 45.9858 38.3424 45.9858 43.6511C45.9858 48.9597 50.1762 53.1408 55.7198 53.1408C61.2633 53.1408 65.4799 48.9575 65.4799 43.6511C65.4799 38.3446 61.2895 34.1592 55.7198 34.1592ZM55.7198 48.9315C52.745 48.9315 50.6106 46.5185 50.6106 43.6511C50.6106 40.7836 52.745 38.3684 55.7198 38.3684C58.6945 38.3684 60.829 40.7814 60.829 43.6511C60.829 46.5207 58.6924 48.9315 55.7198 48.9315Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.186 44.2651L71.6429 34.5352H68.2622V52.7658H72.8324L72.8062 43.5682L76.9158 49.8702V49.8962H79.4563V49.8702L83.5375 43.6223V52.7658H88.1077V34.5352H84.703L78.186 44.2651Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.679 33.2998L97.757 36.0937L96.9844 37.8899L103.124 34.4122L102.679 33.2998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7686 52.7664H95.6355L96.8534 49.6284H104.638L105.882 52.7664H110.723L103.255 35.1807L96.6264 39.0198L90.7707 52.7686L90.7686 52.7664ZM98.3658 45.7698L100.745 39.7102L103.124 45.7698H98.3658Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.979 38.5821H116.847V52.7658H121.417V38.5821H127.258V34.5352H110.979V38.5821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.069 34.5352H129.499V52.7658H134.069V34.5352Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.586 38.3965C149.019 38.3965 150.641 39.8184 151.156 42.095H155.833C155.265 37.3751 151.643 34.1592 146.612 34.1592C141.071 34.1592 136.878 38.1542 136.878 43.6511C136.878 49.1479 141.068 53.1408 146.612 53.1408C151.643 53.1408 155.263 49.9227 155.833 45.2049H151.156C150.641 47.4837 149.019 48.9056 146.586 48.9056C143.585 48.9056 141.503 46.6808 141.503 43.6511C141.503 40.6213 143.585 38.3965 146.586 38.3965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.513 34.4277H165.159L157.346 52.7666H162.213L163.428 49.6286H171.215L172.46 52.7666H177.3L169.513 34.4277ZM164.943 45.7678L167.322 39.7082L169.701 45.7678H164.943Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5766 25.1321C89.1947 25.1321 88.8237 24.9352 88.6207 24.5846C88.3151 24.0609 88.4963 23.3922 89.0244 23.0892L129.027 0.14726C129.556 -0.155718 130.23 0.023905 130.536 0.547625C130.841 1.07134 130.66 1.74006 130.132 2.04304L90.1266 24.985C89.9542 25.0845 89.7621 25.1321 89.5766 25.1321Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.455 25.0972C71.0731 25.0972 70.7021 24.9003 70.4991 24.5497C70.1935 24.0259 70.3747 23.3572 70.9029 23.0542L100.897 5.84941C101.425 5.54643 102.1 5.72605 102.405 6.24977C102.711 6.77349 102.529 7.44221 102.001 7.74519L72.0072 24.95C71.8326 25.0496 71.6427 25.0972 71.455 25.0972Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2946 25.0973C52.9171 25.0973 52.5504 24.9025 52.3474 24.5562C52.0462 24.039 52.2252 23.3768 52.7468 23.0781L72.9088 11.5347C73.4326 11.236 74.0982 11.4135 74.3994 11.9307C74.7006 12.4479 74.5216 13.1102 74 13.4088L53.8381 24.9523C53.6657 25.0497 53.478 25.0973 53.2924 25.0973H53.2946Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2119_40747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 63,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInfomaticaActivo200X70);
export default __webpack_public_path__ + "static/media/LOGO_INFOMATICA_ACTIVO_200X70.c6aef4bba782de11cdc5996f51bb2ad0.svg";
export { ForwardRef as ReactComponent };